import React from 'react';
import { ContentCard, ContentCardLogoLeading } from '../ContentCard';

interface IntegrationCardProps {
  title: string;
  excerpt: string;
  slug: string;
  coverImageUrl?: string | null;
}

export function IntegrationCard({ title, excerpt, slug, coverImageUrl }: IntegrationCardProps) {
  return (
    <ContentCard
      href={`/articles/${slug}`}
      title={title}
      excerpt={excerpt}
      titleEmphasis="medium"
      leading={<ContentCardLogoLeading imageUrl={coverImageUrl} title={title} />}
    />
  );
}
